import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_PN: TStep[] = [
  {
    pageId: PageId.SEX_PN,
  },
  {
    pageId: PageId.DOG_AGE_PN,
  },
  {
    pageId: PageId.BIGGEST_CHALLENGE_PN,
  },
  {
    pageId: PageId.URGE_PN,
  },
  {
    pageId: PageId.DOG_BREED_PN,
  },
  {
    pageId: PageId.DOG_BREED_ID_PN,
  },
  {
    pageId: PageId.CHALLENGES_PN,
  },
  {
    pageId: PageId.FEELINGS_PN,
  },
  {
    pageId: PageId.URGE_2_PN,
  },
  {
    pageId: PageId.REACTION_PN,
  },
  {
    pageId: PageId.YELLING_MOMENTS_PN,
  },
  {
    pageId: PageId.BARKING_PN,
  },
  {
    pageId: PageId.URGE_3_PN,
  },
  {
    pageId: PageId.IMPROVE_PN,
  },
  {
    pageId: PageId.FOLLOW_COMMANDS_PN,
  },
  {
    pageId: PageId.COMMANDS_61_PN,
  },
  {
    pageId: PageId.COMMANDS_62_PN,
  },
  {
    pageId: PageId.COMMANDS_63_PN,
  },
  {
    pageId: PageId.URGE_4_PN,
  },
  {
    pageId: PageId.TOYS_PN,
  },
  {
    pageId: PageId.FREQUENCY_PN,
  },
  {
    pageId: PageId.PREPARE_FLOW_PN,
  },
  {
    pageId: PageId.DOG_STATISTICS_PN,
  },
  {
    pageId: PageId.EMAIL_PN,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_PN,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_PN,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_PN,
  },
  {
    pageId: PageId.CHAT_UPSELL_PN,
  },
  {
    pageId: PageId.UPSELL_PN,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
  {
    pageId: PageId.DOWNLOAD_PN,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PN.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PN.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
